module.exports = __webpack_public_path__ + "img/empty-ped.c516e513.svg";